import React from 'react';
import CheckItem from './index';
import {CheckboxGroupProps} from "antd/lib/checkbox/Group";


export interface CheckItemGroupState {
    value?: any;
}
 
export interface  CheckItemGroupProps  extends CheckboxGroupProps{
    options:any
}
// eslint-disable-next-line react/prefer-stateless-function
class OptionalLabel extends React.Component<CheckItemGroupProps, CheckItemGroupState> {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue,
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if ('value' in nextProps) {
      return {
        value: nextProps.value || [],
      };
    }
    return null;
  }

  handleChange = (e, v) => {
    const { onChange } = this.props;
    const value = [...this.state.value];
    const { checked } = e.target;
    if (checked) {
      value.push(v.value);
    } else {
      value.splice(value.indexOf(v.value), 1);
    }
    this.setState({ value });
    if (onChange) {
      onChange(value);
    }
  };

  render() {
    const { options } = this.props;
    const { value } = this.state;
    return (
        <div>
          {options.map(v => (
            <CheckItem
              key={v.value}
              label={v.label}
              checked={Array.isArray(value) && value.length > 0 ? value.includes(v.value) : false}
              onChange={e => this.handleChange(e, v)}
            />
          ))}
        </div>
    );
  }
}

export default OptionalLabel;



// WEBPACK FOOTER //
// ./src/components/check-item/Group.tsx